import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Sparkles, X, Send, User, Bot, Loader2 } from 'lucide-react';

// 👑 IMPORT FONDAMENTALI
import { getFunctions, httpsCallable } from "firebase/functions";
// ❌ RIMUOVILO: import { app } from "./firebase";
import { useUser } from "./UserContext"; 

export default function AuraCopilotWidget() {
    const [isOpen, setIsOpen] = useState(false);
    
    // 🧠 IL CERVELLO
    const [messages, setMessages] = useState([
        { id: 1, sender: 'bot', text: 'Ciao! Sono Aura Copilot ⚡️. Come posso aiutarti con il personale oggi?' }
    ]);
    const [inputText, setInputText] = useState('');
    const [isTyping, setIsTyping] = useState(false);
    
    // 👑 PRELEVIO DATI DAL CONTESTO HR
    const { userProfile, activeCenterId } = useUser();

    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(() => {
        if (isOpen) {
            setTimeout(scrollToBottom, 50);
        }
    }, [messages, isOpen]);

    const handleSendMessage = async (e) => {
        e.preventDefault();
        if (!inputText.trim()) return;

        const userMsg = inputText.trim();
        setMessages(prev => [...prev, { id: Date.now(), sender: 'user', text: userMsg }]);
        setInputText('');
        setIsTyping(true);

        const currentPath = window.location.pathname;
        
        try {
            // 🎯 FIX CHIRURGICO: Inizializza functions SENZA passare "app". 
            // Firebase userà l'istanza di default automaticamente.
            const functions = getFunctions(undefined, "europe-west1"); 
            const askCopilotFn = httpsCallable(functions, "askAuraCopilot");

            // 2. Chiamata reale alla Cloud Function (Gemini)
            const res = await askCopilotFn({
                userMessage: userMsg,
                currentPath: currentPath,
                appSource: "hr", // 👑 FONDAMENTALE: Attiva il manuale del Master HR
                centerId: activeCenterId || userProfile?.centerId || "default" // Passa l'ID del centro per l'Audit
            });

            // 3. Mostra la risposta reale
            setMessages(prev => [...prev, { 
                id: Date.now() + 1, 
                sender: 'bot', 
                text: res.data.answer 
            }]);
            
        } catch (error) {
            console.error("Errore Copilot HR:", error);
            setMessages(prev => [...prev, { 
                id: Date.now() + 1, 
                sender: 'bot', 
                text: "Ops! Non sono riuscito a raggiungere la mia knowledge base. Riprova tra poco. 😢" 
            }]);
        } finally {
            setIsTyping(false);
        }
    };

    // ... IL RESTO DEL FILE RIMANE IDENTICO A QUELLO DI PRIMA
    // 🎯 IL MODALE (Disegnato tramite Portal per essere sempre in primo piano)
    const modalContent = isOpen ? createPortal(
        <div 
            // OVERLAY SCURO E A SCHERMO INTERO ASSOLUTO
            style={{ 
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, 
                backgroundColor: 'rgba(0, 0, 0, 0.15)', 
                backdropFilter: 'blur(2px)', 
                zIndex: 999999, 
                display: 'flex', justifyContent: 'center', alignItems: 'center',
                animation: 'fadeIn 0.2s ease-out'
            }}
            onClick={() => setIsOpen(false)} // Chiudi se clicchi fuori
        >
            <div 
                // CONTAINER DELLA CHAT
                style={{
                    width: '90%', maxWidth: '420px', 
                    height: '550px', maxHeight: '80vh',
                    backgroundColor: 'white', borderRadius: '16px',
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.15)',
                    display: 'flex', flexDirection: 'column', border: '1px solid #e5e7eb',
                    overflow: 'hidden', animation: 'zoomIn 0.2s ease-out'
                }}
                onClick={e => e.stopPropagation()} // Ferma il click per non chiudere il modale
            >
                
                {/* HEADER */}
                <div style={{
                    padding: '12px 16px', backgroundColor: '#f9fafb', borderBottom: '1px solid #e5e7eb',
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div style={{ background: '#e0e7ff', padding: '6px', borderRadius: '8px', display: 'flex' }}>
                            <Sparkles size={16} color="#4f46e5"/>
                        </div>
                        <div>
                            <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: 'bold', color: '#1e293b' }}>Aura Copilot</h3>
                            <span style={{ fontSize: '0.75rem', color: '#64748b' }}>Assistente HR</span>
                        </div>
                    </div>
                    <button onClick={() => setIsOpen(false)} style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', padding: '4px', display: 'flex' }}>
                        <X size={20} />
                    </button>
                </div>

                {/* CORPO MESSAGGI */}
                <div style={{ flex: 1, overflowY: 'auto', padding: '16px', backgroundColor: '#f8fafc', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    {messages.map((msg) => {
                        const isUser = msg.sender === 'user';
                        return (
                            <div key={msg.id} style={{ display: 'flex', gap: '8px', alignItems: 'flex-end', alignSelf: isUser ? 'flex-end' : 'flex-start', maxWidth: '85%' }}>
                                {!isUser && <div style={{ width: '24px', height: '24px', borderRadius: '50%', backgroundColor: '#e0e7ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Bot size={14} color="#4f46e5"/></div>}
                                
                                <div style={{
                                    padding: '10px 14px', borderRadius: '14px', fontSize: '0.9rem', lineHeight: '1.4',
                                    backgroundColor: isUser ? '#4f46e5' : 'white',
                                    color: isUser ? 'white' : '#1e293b',
                                    border: isUser ? 'none' : '1px solid #e2e8f0',
                                    borderBottomRightRadius: isUser ? '4px' : '14px',
                                    borderBottomLeftRadius: !isUser ? '4px' : '14px',
                                    whiteSpace: 'pre-wrap'
                                }}>
                                    {msg.text}
                                </div>
                                {isUser && <div style={{ width: '24px', height: '24px', borderRadius: '50%', backgroundColor: '#cbd5e1', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><User size={14} color="white"/></div>}
                            </div>
                        );
                    })}
                    
                    {isTyping && (
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end', alignSelf: 'flex-start' }}>
                            <div style={{ width: '24px', height: '24px', borderRadius: '50%', backgroundColor: '#e0e7ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Bot size={14} color="#4f46e5"/></div>
                            <div style={{ padding: '10px 14px', borderRadius: '14px', backgroundColor: 'white', border: '1px solid #e2e8f0', borderBottomLeftRadius: '4px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <Loader2 size={14} color="#4f46e5" style={{ animation: 'spin 1s linear infinite' }} />
                                <span style={{ fontSize: '0.85rem', color: '#64748b' }}>Sta pensando...</span>
                            </div>
                        </div>
                    )}
                    <div ref={messagesEndRef} />
                </div>

                {/* INPUT AREA */}
                <div style={{ padding: '12px', backgroundColor: 'white', borderTop: '1px solid #e2e8f0' }}>
                    <form onSubmit={handleSendMessage} style={{ display: 'flex', gap: '8px', alignItems: 'flex-end' }}>
                        <textarea
                            value={inputText}
                            onChange={(e) => setInputText(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSendMessage(e);
                                }
                            }}
                            placeholder="Chiedi ad Aura..."
                            style={{ flex: 1, padding: '8px 12px', borderRadius: '10px', border: '1px solid #d1d5db', fontSize: '0.9rem', outline: 'none', resize: 'none', maxHeight: '80px', minHeight: '38px', fontFamily: 'inherit' }}
                            rows={1}
                        />
                        <button 
                            type="submit" 
                            disabled={!inputText.trim() || isTyping}
                            style={{ width: '38px', height: '38px', borderRadius: '10px', backgroundColor: (!inputText.trim() || isTyping) ? '#cbd5e1' : '#4f46e5', color: 'white', border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: (!inputText.trim() || isTyping) ? 'not-allowed' : 'pointer', flexShrink: 0 }}
                        >
                            <Send size={16} style={{ marginLeft: '2px' }} />
                        </button>
                    </form>
                </div>
            </div>
        </div>,
        document.body // Inserisce il componente direttamente nel tag body!
    ) : null;

    return (
        <>
            {/* BOTTONE NELLA NAVBAR (Solo Scintilla) */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                style={{
                    width: '36px', height: '36px', borderRadius: '50%',
                    background: isOpen ? '#e5e7eb' : 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                    color: isOpen ? '#1e293b' : 'white', border: 'none',
                    boxShadow: isOpen ? 'inset 0 2px 4px rgba(0,0,0,0.1)' : '0 4px 10px rgba(79, 70, 229, 0.3)',
                    cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    transition: 'all 0.2s', padding: 0
                }}
                onMouseEnter={(e) => { if(!isOpen) { e.currentTarget.style.transform = 'scale(1.1)'; } }}
                onMouseLeave={(e) => { if(!isOpen) { e.currentTarget.style.transform = 'scale(1)'; } }}
                title="Aura Copilot"
            >
                <Sparkles size={18} />
            </button>

            {/* Renderizza il modale solo se isOpen è true */}
            {modalContent}
            
            <style>{`
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes zoomIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
                @keyframes spin { 100% { transform: rotate(360deg); } }
            `}</style>
        </>
    );
}